// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 23:44:32

export default {
  "id": "hotel-fever-tycoon",
  "slug": "hotel-fever-tycoon",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c35eb9b0918b42b1b01d6d256e02a332-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c35eb9b0918b42b1b01d6d256e02a332/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Hotel Fever Tycoon",
      "description": "Wanna be a Hotel Empire Tycoon or a Top Cooking Chef? Come to \"Hotel Fever Tycoon\" to start an interesting hotel management and cooking ourney with Emma and Uncle George! Work together to build your world-class hotel chain!",
      "instructions": "Work hard to upgrade the hotel, complete each guest's order efficiently to unlock more theme hotels",
      "genres": [
        "Casual"
      ],
      "tags": [
        "hotel"
      ]
    },
    "zh-CN": {
      "title": "酒店热症大亨",
      "description": "想要成为酒店帝国大亨还是顶尖烹饪大师？来“酒店狂热大亨”开始与艾玛和乔治叔叔一起进行的有趣的酒店管理和烹饪之旅！携手共建您世界级的酒店连锁！",
      "instructions": "努力提升酒店，高效完成每位顾客的订单以解锁更多主题酒店",
      "genres": [
        "休闲"
      ],
      "tags": [
        "酒店"
      ]
    },
    "zh-TW": {
      "title": "酒店瘋狂大亨",
      "description": "想成為酒店帝國大亨或頂級烹飪大師嗎？來「酒店瘋狂大亨」開啟與艾瑪和湯瑪士叔叔一起的有趣酒店經營與烹飪之旅！攜手打造您的世界級酒店集團！",
      "instructions": "努力升級飯店，高效完成每位客人的訂單以解鎖更多主題飯店",
      "genres": [
        "休闲"
      ],
      "tags": [
        "酒店"
      ]
    },
    "zh-HK": {
      "title": "酒店瘋狂大亨",
      "description": "想成為酒店帝國大亨還是頂級烹飪大師？來到《酒店瘋狂大亨》與Emma和Uncle George開始一段有趣的酒店管理和烹飪之旅！攜手建立您全球級的酒店集團！",
      "instructions": "努力升級酒店，高效完成每位客人的訂單以解鎖更多主題酒店",
      "genres": [
        "隨意"
      ],
      "tags": [
        "酒店"
      ]
    },
    "ja": {
      "title": "ホテル・フィーバー・タイコン",
      "description": "ホテル帝国総帥や一流の料理長になりたいですか？「ホテル・フィーバー・タイコン」に来て、エマとアンカージョージと一緒に面白いホテル経営と料理の冒険を始めましょう！協力して、世界クラスのホテルチェーンを築きましょう！",
      "instructions": "ホテルを一生懸命アップグレードし、各客の注文を効率的に完了して、もっとテーマホテルを解除する",
      "genres": [
        "カジュアル"
      ],
      "tags": [
        "ホテル"
      ]
    },
    "ko": {
      "title": "호텔 파이어 타이콘",
      "description": "호텔 الإمبر러스 라이벌이나 최고의 요리사가 되고 싶어요? \"호텔 페버 라이벌\"에 오세요. 엠마와 언큰 조지와 함께 흥미로운 호텔 운영 및 요리 여정을 시작하세요! 함께 세계적인 호텔 체인을 건설하세요!",
      "instructions": "호텔을 열심히 업그레이드하고, 각 손님의 주문을 효율적으로 완료하여 더 많은 테마 호텔을 개방하세요.",
      "genres": [
        "캐주얼"
      ],
      "tags": [
        "호텔"
      ]
    },
    "fr": {
      "title": "Hotellerie Fievre Tycoon",
      "description": "Voulez-vous devenir un tycoon de l'empire hôtelier ou un chef cuisinier en chef ? Venez à \"Hotel Fever Tycoon\" pour commencer un voyage fascinant de gestion hôtelière et de cuisine avec Emma et Uncle George ! Travaillez ensemble pour construire votre chaîne hôtelière de classe mondiale !",
      "instructions": "Travaille dur pour améliorer l'hôtel, complete chaque commande des clients efficacement pour déverrouiller plus d'hôtels thématiques",
      "genres": [
        "Casuel"
      ],
      "tags": [
        "hôtel"
      ]
    }
  }
};
